import { client } from "@lib/api"
import { useTranslation } from "react-i18next"
import { useState } from "react"
import { ApiError } from "@lib/api"

const useReferral = () => {
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState('')

    const postReferral = async ({ referral_code }: { referral_code: string }) => {
        try {
            setError('')
            setIsLoading(true)
            await client.doPost('/v2/wallet/referral', { referral_code })
            return true
        } catch (error: unknown) {
            if (error instanceof ApiError && error.errorCode) {
                setError(t(`errors.${error.errorCode}.description`))
            } else {
                setError(t('page.createWallet.steps.referralCode.errorText'))
            }
            return false
        } finally {
            setIsLoading(false)
        }
    }

    return {
        postReferral,
        isLoading,
        error
    }
}

export default useReferral